import React from "react"
import { Button } from "react-bootstrap"

import { moveGraphToNewLocation } from "./utils"
import ObservationSelectorPopper from "../widgets/ObservationSelectorPopper"
import { isLTPM } from "../../../../components/shared_components_registration"

// Where we set distinctions for LTPM/LL versions of the component
const registration = {
  remove_graph: (intl) => (isLTPM ? intl.formatMessage({ id: "graphing.remove.graph" }) : "Remove Graph"),
}

export default function KeyHeader({
  index,
  plotList,
  updateGraphs,
  title,
  placement,
  graphNum,
  siteReactors = [],
  intl,
  disabled = false,
}) {
  return (
    <div className={"plot-key-header"}>
      <div style={{ flex: 1 }}>
        <div style={{ display: "flex" }} id={"obs-selector-popper-wrap"}>
          <ObservationSelectorPopper
            placement={placement}
            options={plotList}
            nameFn={(plot) => plot.title}
            onSelect={(sel) => {
              updateGraphs((graphs) => {
                const newGraphs = Object.assign([], graphs)
                newGraphs[index] = Object.assign({}, sel)
                return newGraphs
              })
            }}
            runFilters={siteReactors}
          >
            <Button variant={"outline-primary"} disabled={disabled}>
              {title}
            </Button>
          </ObservationSelectorPopper>
          &nbsp;
          <div>
            <select
              name={"graph_location"}
              className={"form-select form-select-sm"}
              value={index}
              disabled={graphNum <= 1 || disabled}
              onChange={(e) => {
                e.target.value !== index && moveGraphToNewLocation(updateGraphs, index, e.target.value)
              }}
            >
              {Array.from(Array.from(Array(graphNum).keys())).map((item, idx) => (
                <option key={idx} value={item}>
                  {`${item + 1}/${graphNum}`}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <Button
        title={registration["remove_graph"](intl)}
        variant={"outline-primary"}
        disabled={disabled}
        onClick={() => updateGraphs((graphs) => graphs.filter((_, fidx) => fidx !== index))}
      >
        <span className="fa fa-minus-circle" />
      </Button>
    </div>
  )
}
